import { z } from "zod";

import { filter } from "~/tools/filter";
import { isPresent } from "~/tools/is-present";
import { Template } from "~/tools/template";

const FALLBACK_DASHBOARD_WIDGET_LINK_URL = Template<null>("");
const FALLBACK_DASHBOARD_WIDGET_LINK = {
	url: FALLBACK_DASHBOARD_WIDGET_LINK_URL,
};

const dashboardWidgetLinkSchema = z
	.object({
		url: z
			.string()
			.trim()
			.min(1)
			.transform((url) => Template<null>(url))
			.catch(FALLBACK_DASHBOARD_WIDGET_LINK_URL),

		name: z
			.string()
			.trim()
			.transform((name) => Template<null>(name))
			.optional()
			.catch(undefined),

		tooltip: z
			.string()
			.trim()
			.transform((tooltip) => Template<null>(tooltip))
			.optional()
			.catch(undefined),

		targetBlank: z.boolean().optional().catch(undefined),
	})
	.catch(FALLBACK_DASHBOARD_WIDGET_LINK);

export type DashboardWidgetLink = z.infer<typeof dashboardWidgetLinkSchema>;

export const dashboardWidgetLinks = z
	.array(dashboardWidgetLinkSchema.optional().catch(undefined))
	.catch([])
	.transform(filter(isPresent));
